import { render, staticRenderFns } from "./coupon-config.vue?vue&type=template&id=2921621e&scoped=true&"
import script from "./coupon-config.vue?vue&type=script&lang=js&"
export * from "./coupon-config.vue?vue&type=script&lang=js&"
import style0 from "./coupon-config.vue?vue&type=style&index=0&id=2921621e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921621e",
  null
  
)

export default component.exports